<template>
  <div class="page-header" v-if="breadcrumbs && breadcrumbs.length">
    <ol class="breadcrumb">
      <li v-if="!noUseMainPage" @click="mixinGoToRouter('home')" class="breadcrumb-item"><a href="#">Главная</a></li>
      <template v-for="b in breadcrumbs">
        <li v-if="b.routeName || customAction"
            @click="customAction ? customAction(b) : mixinGoToRouter(b.routeName,b.params)"
            class="breadcrumb-item"><a
          href="#">{{ b.title }}</a></li>
        <li v-else class="breadcrumb-item active">{{ b.title }}</li>
      </template>
    </ol>
  </div>
</template>

<script>

export default {
  props: ['breadcrumbs', 'noUseMainPage', 'customAction']
}

</script>
